






























import { Component, Vue, Prop, Watch } from "vue-property-decorator";

@Component({
  name: "InvoiceType",
})
export default class InvoiceType extends Vue {
  @Prop({ required: true }) model!: any;
  @Prop({ required: true }) optionType!: any;

  private showForm = false;
  public optionList: any = [];

  @Watch("optionType")
  updateOptions() {
    this.optionList = this.optionType;
  }

  onShowFormAddInvoiceType() {
    this.showForm = true;
  }

  onCloseAddInvoiceType() {
    this.showForm = false;
    this.optionList = [];
    for (const opt of this.model.CustomField.InvoiceType) {
      this.optionList.push({ text: opt, value: opt });
    }
  }
}
